import React, { useEffect } from 'react';
import proptypes from 'prop-types';
const { shape } = proptypes;
import { BrowseSearchErrorB2C } from '@thd-olt-component-react/error-components';
import { BrowseSearchErrorB2B } from '@thd-olt-component-react/error-components';

export const BrowseError = (props) => {
  const { customer } = props;
  return (customer.type === 'b2b' ? <BrowseSearchErrorB2B /> : <BrowseSearchErrorB2C />);
};

BrowseError.propTypes = {
  customer: shape({})
};

BrowseError.defaultProps = {
  customer: null
};